// @flow
import * as React from 'react'
import { type Filters } from '..'

import './SearchBar.module.scss'

type Props = {
  location: string,
  onUpdateFilters: (filters: $Shape<Filters>) => void,
  onSearch: () => void,
}

const PLACEHOLDER = 'Where are you looking for child care?'

export default class SearchBar extends React.Component<Props> {
  render = () => {
    return (
      <form styleName="root" onSubmit={this.handleSubmit}>
        <input
          styleName="input"
          type="search"
          value={this.props.location}
          placeholder={PLACEHOLDER}
          autoFocus
          onChange={this.handleChange}
        />
      </form>
    )
  }

  handleSubmit = (event: SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault()
    this.props.onSearch()
  }

  handleChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    this.props.onUpdateFilters({ location: event.target.value })
  }
}
